import { toRem, toRems } from "../../../../../helpers/theme";

/* eslint-disable quote-props, no-dupe-keys, max-len */
const style = ({ theme, sticky }) => ({
    overflow: "hidden",
    display: "flex",
    backgroundColor: theme.colors.userProfileHead.tabs.background,
    borderTop: `1px solid ${theme.colors.userProfileHead.tabs.border}`,
    [theme.breakpoints.down("md")]: {
        minHeight: toRem(52),
    },
    ".Nav": {
        position: "relative",
        transform: "translateZ(0)",
        width: "100%",
        "&::after": {
            zIndex: theme.zIndex.over,
            content: '""',
            pointerEvents: "none",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            height: toRem(52),
            width: toRem(20),
            background: "linear-gradient(270deg, #fff 0%, rgba(255, 255, 255, 0) 100%)",
        },
        ...(sticky && {
            [theme.breakpoints.down("md")]: {
                zIndex: theme.zIndex.header,
                overflow: "hidden",
                position: "fixed",
                top: 0,
                left: toRem(15),
                width: `calc(100% - ${toRem(30)})`,
                borderBottomLeftRadius: toRem(15),
                borderBottomRightRadius: toRem(15),
                backgroundColor: theme.colors.white,
                boxShadow: theme.shadows.subtle,
            },
        }),
    },
    ".List": {
        display: "flex",
        overflowX: "auto",
        "&::-webkit-scrollbar": {
            display: "none",
        },
        [theme.breakpoints.up("md")]: {
            marginLeft: toRem(38),
        },
        li: {
            display: "flex",
            flex: "0 0 auto",
            a: {
                display: "block",
                padding: toRems([15, 10]),
                [theme.breakpoints.up("md")]: {
                    padding: toRem(20),
                },
                fontWeight: theme.typography.fontWeight.bold,
                textDecoration: "none",
                color: "inherit",
                transition: "color 300ms",
                "&:hover, &.is-active": {
                    color: theme.colors.userProfileHead.tabs.hover,
                },
                "&.is-active": {
                    pointerEvents: "none",
                },
            },
        },
    },
});

export default style;
